import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { PIN, SERVICE, CAN } from 'utils/constants'
import { RadioButtonGroup } from 'components/patterns'

const outputTypeButtons = ({ disableCan, disableNative }) => [
  { value: PIN, text: strings.output_type_pin },
  { value: SERVICE, text: strings.native, disabled: disableNative },
  { value: CAN, text: strings.can, disabled: disableCan },
]

const OutputTypeEditor = ({ output, setOutputType, disableCan, isXMC2 }) => {
  const { type } = output

  const disableNative = isXMC2

  return (
    <RadioButtonGroup
      vertical
      name="type"
      label={strings.output_type}
      onChange={setOutputType}
      currentValue={type}
      buttonStyle="solid"
      buttons={outputTypeButtons({
        disableNative,
        disableCan,
      })}
      className="function-output-type-editor"
      radioGroupClassName="output-type-radio-group"
    />
  )
}

OutputTypeEditor.propTypes = {
  output: PropTypes.shape({
    type: PropTypes.string,
  }),
  setOutputType: PropTypes.func,
  hasOutputQuery: PropTypes.bool,
  disableCan: PropTypes.bool,
  isXMC2: PropTypes.bool,
}

export default OutputTypeEditor
